import React, { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import makeImage from '../../components/common/makeImage';

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../../components/recoil/atoms/Menus";

import HeaderUserTitle from "../components/includes/HeaderUserTitle";
import { PassedMonths,ChangeSimpleDateString, unescapeHtml,GetChildrenState,DownloadFile,isNull,isObjEmpty,GetBookName,ChangeSearchingDateFormat } from "../../components/common/Common";

//FLY 발달 진도표
const AnalysisFly = () => {
  const { clc_idx } = useParams();

  //Image 선언
  const imgMaker = makeImage();

  const [varParentMenus,setParentMenus] = useRecoilState(ParentsMenus);

  const [varClassChildrenInfo,setClassChildrenInfo] = useState({}); //원생/클라스 정보
  const [varStudyStepIndex,setStudyStepIndex] = useState(0); //선택된 chapter

  const [varEvaluationList,setEvaluationList] = useState([]); //진도별 평가 목록
  const [varEvaluationInfo,setEvaluationInfo] = useState({}); //선택된 평가 정보

  const [varFlyChecksList,setFlyChecksList] = useState([]);   //전체 플라이 교육정보
  const [varFlyClassList,setFlyClassList] = useState([]); 
  const [varFlyStepList,setFlyStepList] = useState([]); 
  const [varFlyChapterList,setFlyChapterList] = useState([]); 

  const GetEvaluationList = async () => {
    const sendData = {clc_idx:clc_idx};
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_childrens_fly`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const childrenInfo = datas.results[0];
        setClassChildrenInfo(childrenInfo);

        //전체 플라이 교육정보
        const flyalls = datas.flyalls;
        setFlyChecksList(flyalls);

        //플라이 클래스 과목
        const flythemes = datas.flythemes;
        setFlyClassList(flythemes);

        //차수
        const flyStepList = [];
        const flyChapterList = [];
        for(var i=1; i <= 12; i++) {
          flyStepList.push(i);
          if(i <= 4) {
            flyChapterList.push(i);
          }
        }
        setFlyStepList(flyStepList);
        setFlyChapterList(flyChapterList);
        
        //평가 결과 정보 읽기
        GetEvaluationInformation(childrenInfo.cl_idx,childrenInfo.ch_idx);
      } 
    });
  }

  //평가 결과 정보 읽기
  const GetEvaluationInformation = async(cl_idx,ch_idx) => {
    const sendData = {cl_idx:cl_idx,ch_idx:ch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_evaluation_fly`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const evaluationList = datas.evaluationList;
        setEvaluationList(evaluationList);
        setStudyStepIndex(evaluationList[0].csc_idx);
      }
    });
  }
  
  //최초실행부
  useEffect(() => {
    console.log(varParentMenus);
    setParentMenus({showMenu:false,gotoMain:0});
    GetEvaluationList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(varStudyStepIndex > 0) {
      //선택된 단계에 대한 원생 + 평가 정보
      const studyStepData = varEvaluationList.find(el=>el.csc_idx === varStudyStepIndex);
      console.log(studyStepData);
      if(isNull(studyStepData.vts_idx)) studyStepData.vts_idx = 1;
      if(isNull(studyStepData.vtc_chapter)) studyStepData.vtc_chapter = 1;
      studyStepData.bookname = GetBookName(studyStepData.vt_name,studyStepData.vts_idx);
      setEvaluationInfo(studyStepData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varStudyStepIndex]);

  //단계 변경
  const onChangeStudyStepHandler = (e) => {
    const csc_idx = Number(e.currentTarget.value);
    setStudyStepIndex(csc_idx);
  }

  //과목/단계/Chapter 선택
  const onChangeClassStepHandler = (e) => {
    const {name,value } = e.currentTarget;
    if(name === "vt_idx") {
      const selData = varFlyClassList.find(el=>el.vt_idx === Number(value));
      let vts_idx = 1;
      if(!isNull(varEvaluationInfo.vts_idx)) vts_idx = varEvaluationInfo.vts_idx;
      let bookname = GetBookName(selData.vt_name,vts_idx);
      const flyData = varFlyChecksList.find(el=>el.vt_idx===Number(value) && el.vts_idx===varEvaluationInfo.vts_idx && el.vtc_chapter===varEvaluationInfo.vtc_chapter);
      if(isNull(flyData)) setEvaluationInfo({...varEvaluationInfo,vt_idx:Number(value),bookname:bookname});
      else setEvaluationInfo({...varEvaluationInfo,vt_idx:Number(value),bookname:bookname,vtc_purpose_direct:flyData.vtc_purpose_direct,
        vtc_purpose_indirect:flyData.vtc_purpose_indirect,vtc_next_class:flyData.vtc_next_class,vtc_idx:flyData.vtc_idx});
    } else if(name === "vts_idx") {
      const selData = varFlyClassList.find(el=>el.vt_idx === varEvaluationInfo.vt_idx);
      let bookname =GetBookName(selData.vt_name,Number(value));
      const flyData = varFlyChecksList.find(el=>el.vt_idx===varEvaluationInfo.vt_idx && el.vts_idx===Number(value) && el.vtc_chapter===varEvaluationInfo.vtc_chapter);
      if(isNull(flyData)) setEvaluationInfo({...varEvaluationInfo,vts_idx:Number(value),bookname:bookname});
      else setEvaluationInfo({...varEvaluationInfo,vts_idx:Number(value),bookname:bookname,vtc_purpose_direct:flyData.vtc_purpose_direct,
          vtc_purpose_indirect:flyData.vtc_purpose_indirect,vtc_next_class:flyData.vtc_next_class,vtc_idx:flyData.vtc_idx});
    } else if(name === "vtc_chapter") {
      const flyData = varFlyChecksList.find(el=>el.vt_idx===varEvaluationInfo.vt_idx && el.vts_idx===varEvaluationInfo.vts_idx && el.vtc_chapter===Number(value));
      if(isNull(flyData)) setEvaluationInfo({...varEvaluationInfo,vtc_chapter:Number(value)});
      else setEvaluationInfo({...varEvaluationInfo,vtc_chapter:Number(value),vtc_purpose_direct:flyData.vtc_purpose_direct,
            vtc_purpose_indirect:flyData.vtc_purpose_indirect,vtc_next_class:flyData.vtc_next_class,vtc_idx:flyData.vtc_idx});
    } else {
      setEvaluationInfo({...varEvaluationInfo,[name]:Number(value)});
    }
  }

  //진도표 이미지 다운로드
  const onDownloadImageHandler = async(e) => {
    if(!window.confirm('플라이 진도표를 사진첩에 저장합니까?')) return false;
    e.preventDefault();
    //버튼 감추기
    document.getElementById('img_button').style.display = "none";
    //파일명 생성
    const sdate = ChangeSearchingDateFormat(new Date(),'');
    const fileName = `플라이_${sdate}.png`;
    //Imageg 파일 생성
    await imgMaker.viewWithImage('mdt-con',fileName);
    document.getElementById('img_button').style.display = "";
  }
  
  //첨부파일 다운로드 - 플라이진도표
  const onAttachDownloadHandler = (e) => {
    const downfile = `${process.env.REACT_APP_HOST}/flys/${varEvaluationInfo.ev_file}`;
    DownloadFile(downfile,varEvaluationInfo.ev_real_file,2);
  }

  return(
    <div className="vh-content normal-wrap">
      <HeaderUserTitle varPageTitle={'플라이 진도표'} varBackString={'/Parents/Analysis'}/>
      <div className="vh-content-body ct-mdt-wrap" style={{marginTop:"60px"}}>
        <div className="mdt-con fly-add-con">
          <div className="center-wrap">
            <div className="mdt-info">
              <div className="line">
                <div className="name">{varClassChildrenInfo.ch_name} {PassedMonths(varClassChildrenInfo.ch_birthday)}개월</div>
                <div>{ChangeSimpleDateString(varClassChildrenInfo.ch_birthday)} ({GetChildrenState(varClassChildrenInfo.ch_status)})</div>
              </div>
              <ul>
                <li><p>학기명</p><div>{varClassChildrenInfo.sm_name}</div></li>
                <li><p>클래스명</p><div>{varClassChildrenInfo.cl_name}</div></li>
                <li><p>차수</p><div>{varClassChildrenInfo.pass_cnt}/{varClassChildrenInfo.tstudys}</div></li>
              </ul>
            </div>
            <button className="btn-yes" id="img_button" onClick={e=>onDownloadImageHandler(e)}>다운로드</button>

            {/* 플라이 진도표 */}
            <div className="mdt-box fly-box">
              <p className="mdt-tit">플라이 진도표</p>
              <div className="fly-view-box">
                {varEvaluationList.length===0?null:
                  <div className="fly-input-line">
                    <p>원생 수업 단계</p>
                    <div>
                      <select name="" value={varStudyStepIndex||0} style={{width:"120px"}} onChange={e=>onChangeStudyStepHandler(e)}>
                        <option value={0}>단계 선택</option>
                        {varEvaluationList.map((studys,i)=>(
                          <option key={'studys_'+i} value={studys.csc_idx}>{studys.cs_index} 단계</option>
                        ))}
                      </select>
                    </div>
                  </div>
                }
                {/* 플라이 평가 */}
                {isObjEmpty(varEvaluationInfo) || varFlyClassList.length===0?null:
                  <>
                    <div className="fly-input-line">
                      <p>평가 과목</p>
                      <div>
                        <select name="vt_idx" value={varEvaluationInfo.vt_idx||0} style={{width:"120px"}} onChange={e=>onChangeClassStepHandler(e)}>
                          <option value={0}>과목 선택</option>
                          {varFlyClassList.map((checks,i)=>(
                            <option key={'checks_'+i} value={checks.vt_idx}>{`${checks.vt_theme} / ${checks.vt_name}`}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="fly-input-line">
                      <p>평가 단계</p>
                      <div>
                        <select name="vts_idx" value={varEvaluationInfo.vts_idx||0} style={{width:"120px"}} onChange={e=>onChangeClassStepHandler(e)}>
                          {varFlyStepList.map((steps,i)=>(
                            <option key={'steps_'+i} value={steps}>{steps} 단계</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="fly-input-line">
                      <p>Chapter</p>
                      <div>
                        <select name="vtc_chapter" value={varEvaluationInfo.vtc_chapter||0} style={{width:"120px"}} onChange={e=>onChangeClassStepHandler(e)}>
                          {varFlyChapterList.map((chapters,i)=>(
                            <option key={'chapters_'+i} value={chapters}>Chapter{chapters}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="fly-input-line">
                      <p>교재</p>
                      <div>
                        <input type="text" name="bookname" className="read-only" style={{width:"200px"}} value={varEvaluationInfo.bookname||""} readOnly />
                      </div>
                    </div>

                    <div className="fly-input-line">
                      <p>직접 목적</p>
                      <div>
                        <input type="text" name="vtc_purpose_direct" className="read-only" value={varEvaluationInfo.vtc_purpose_direct||""} readOnly />
                      </div>
                    </div>
                    <div className="fly-input-line">
                      <p>간접 목적</p>
                      <div>
                        <input type="text" name="vtc_purpose_indirect" className="read-only" value={unescapeHtml(varEvaluationInfo.vtc_purpose_indirect)} readOnly />
                      </div>
                    </div>
                    <div className="fly-text-line">
                      <p>다음 수업</p>
                      <div>
                        <textarea name="vtc_next_class" className="read-only" value={unescapeHtml(varEvaluationInfo.vtc_next_class)} readOnly/>
                      </div>
                    </div>
                    <div className="fly-text-line">
                      <p>세부 평가</p>
                      <div>
                        <textarea name="ev_memo" className="read-only" value={unescapeHtml(varEvaluationInfo.ev_memo)} readOnly/>
                      </div>
                    </div>
                    <div className={varEvaluationInfo.ev_attach===1?"fly-text-line":"fly-text-line hide"}>
                      <p>첨부파일</p>
                      <p style={{width:"220px"}} onClick={e=>onAttachDownloadHandler(e)}>{varEvaluationInfo.ev_real_file}</p>
                    </div>
                  </>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AnalysisFly;